import DeleteIcon from "@mui/icons-material/Delete";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Box, Card, CardContent, IconButton, Tooltip, Typography } from "@mui/material";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import styles from "./FormAudioDisplay.module.scss";

interface FormAudioDisplayProps {
    fileUrl: string;
    fileType: "audio" | "image" | "video";
    onDelete: () => void;
    label?: string;
}

const FormAudioDisplay = ({ fileUrl, fileType, onDelete }: FormAudioDisplayProps) => {
    const { t } = useTranslation();

    const audioRef = useRef<HTMLAudioElement>(null);

    // Extract filename from URL
    const getFileName = (url: string) => {
        try {
            const urlObj = new URL(url);
            const pathname = urlObj.pathname;
            const fileName = pathname.split("/").pop() || "uploaded-file";
            return decodeURIComponent(fileName);
        } catch {
            return "uploaded-file";
        }
    };

    const handlePreview = () => {
        window.open(fileUrl, "_blank");
    };

    return (
        <Card sx={{ backgroundColor: "#FFF", mb: "1.6rem", boxShadow: "none" }}>
            <CardContent className={styles.cardContent}>
                <Box className={styles.fileInfoBox}>
                    <Box className={styles.fileNameBox}>
                        <InsertDriveFileIcon color='primary' />
                        <Box flex={1}>
                            <Typography variant='body2' className={styles.fileNameText}>
                                {getFileName(fileUrl)}
                            </Typography>
                        </Box>
                    </Box>
                    <Box display='flex' gap={0.5}>
                        {fileType === "video" && (
                            <Tooltip title={t("COMMON.PREVIEW") || "預覽"}>
                                <IconButton size='small' color='primary' onClick={handlePreview}>
                                    <PlayArrowIcon fontSize='small' />
                                </IconButton>
                            </Tooltip>
                        )}
                        {fileType === "image" && (
                            <Tooltip title={t("COMMON.PREVIEW") || "預覽"}>
                                <IconButton size='small' color='primary' onClick={handlePreview}>
                                    <InsertDriveFileIcon fontSize='small' />
                                </IconButton>
                            </Tooltip>
                        )}
                        <Tooltip title={t("COMMON.DEL") || "刪除檔案"}>
                            <IconButton size='small' color='error' onClick={onDelete}>
                                <DeleteIcon fontSize='small' />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                {/* Inline Audio Player for audio files */}
                {fileType === "audio" && (
                    <Box className={styles.audioPlayerBox}>
                        <audio
                            ref={audioRef}
                            src={fileUrl}
                            controls
                            className={styles.audioPlayer}
                            controlsList='nodownload noplaybackrate'
                        />
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default FormAudioDisplay;
